// import * as React from "react";
import { connect } from "react-redux";
import { State } from "../Store";
import Component from "./App";

export default connect(
    // Map state to props
    ({ localization }: State) =>
        ({ localization })
)(Component as any);